import { RouterStore } from 'mobx-react-router'
import { BrandProductsStore, BRAND_PRODUCTS_STORE, ROUTING_STORE } from 'store'

export type ProductsSectionProps = {
  [BRAND_PRODUCTS_STORE]?: BrandProductsStore
  [ROUTING_STORE]?: RouterStore
}

export enum BrandProductsExpandableEntities {
  AGREEMENT = 'agreement',
  PROJECT = 'project'
}
